/**
 * Validates Internal Remote Config API payload and returns a flat key-value map.
 * @param {object} payload
 * @returns {Object.<string, string>}
 */
export default function normalizeInternalRemoteConfigs (payload) {
  if (!payload || payload.success !== true) {
    throw new Error('Invalid remote config response: success !== true');
  }

  const configs = payload.body && payload.body.configs;
  if (!Array.isArray(configs) || configs.length === 0) {
    throw new Error('Invalid remote config response: empty configs');
  }

  const result = {};

  for (const entry of configs) {
    if (!entry || entry.key == null || entry.key === '') continue;
    const key = String(entry.key);
    result[key] = entry.value == null ? '' : String(entry.value);
  }

  if (Object.keys(result).length === 0) {
    throw new Error('Invalid remote config response: no valid keys');
  }

  return result;
}
